export enum DocumentTypeEnum {
  CC = "CC",
  CE = "CE",
}
